//HERContainer.jsx
import { Paper, Typography } from "@mui/material";
import HERView from "./HERComponent/HERView";

const HERContainer = () => {
  return (
    <Paper elevation={3} style={{ padding: "20px" }}>
      <Typography variant="h5" align="left" gutterBottom>
        HER Preview Management
      </Typography>
      <HERView />
    </Paper>
  );
};

export default HERContainer;
